import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcstudent/readytolearn/ReadyToLearn.css";

const ReadyToLearn = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gcStudent-rtl-section" ref={sectionRef}>
      {/* Animated background orbs */}
      <div className="gcStudent-rtl-orb gcStudent-rtl-orb--1" />
      <div className="gcStudent-rtl-orb gcStudent-rtl-orb--2" />
      <div className="gcStudent-rtl-orb gcStudent-rtl-orb--3" />

      <Container className="gcStudent-rtl-container">
        <div
          className={`gcStudent-rtl-content ${
            isVisible ? "gcStudent-rtl-content--visible" : ""
          }`}
        >
          {/* Heading */}
          <h2 className="gcStudent-rtl-title">Ready to Start Learning?</h2>

          {/* Subtitle */}
          <p className="gcStudent-rtl-subtitle">
            Join our digital library platform and get access to thousands of
            resources.
          </p>

          {/* CTA Buttons */}
          <div className="gcStudent-rtl-actions">
            <button
              className="gcStudent-rtl-btn gcStudent-rtl-btn--outline"
              onClick={() => navigate("/student/register")}
            >
              Student Registration
            </button>
            <button
              className="gcStudent-rtl-btn gcStudent-rtl-btn--solid"
              onClick={() => navigate("/library")}
            >
              Browse Library
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ReadyToLearn;